import { z } from 'zod';

export const RedirectUrlDtoSchema = z.object({
  redirectUrl: z.string().url(),
});

export type RedirectUrlDto = z.infer<typeof RedirectUrlDtoSchema>;
